import { __awaiter } from 'tslib';
import { useState } from 'react';
import '../../services/base/baseDiscoverService.js';
import '../../services/base/baseV3Service.js';
import '../../services/base/baseInsightsService.js';
import '../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../utils/ErrorProvider.js';
import '../../utils/LoaderProvider.js';
import '../../utils/RefetchProvider.js';
import '../../utils/NotificationProvider.js';
import '../../utils/ContactProvider.js';
import '../../utils/PolicyProvider.js';
import '../../utils/AnalyticsProvider.js';
import '../../types/AccessDevice.js';
import '../../types/Analytics.js';
import '../../types/CASACommunity.js';
import '../../types/Community.js';
import '../../types/DxSettings.js';
import '../../types/MagicButton.js';
import '../../types/Pannellum.js';
import '../../types/Prospect.js';
import '../../types/ProspectIntelligence.js';
import '../../types/Space.js';
import '../../types/Tour.js';
import '../../utils/analyticsPlugin.js';
import '../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../utils/cookieUtils.js';
import '../../utils/termsConditionsAgreementsUtils.js';
import '../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../services/base/internalApiBaseService.js';
import { getSignedURL } from '../../services/uploadService.js';
import '../../services/base/casaBaseService.js';
import '../../services/scanRequestsService.js';
import '../../services/db/insightsReportsDB.js';
import '../../services/aiDiscoverability.js';

var SIGNED_URL_UPLOAD_TYPE;
(function (SIGNED_URL_UPLOAD_TYPE) {
    SIGNED_URL_UPLOAD_TYPE["FLOORPLAN"] = "floorplan";
    SIGNED_URL_UPLOAD_TYPE["SPACE"] = "space";
    SIGNED_URL_UPLOAD_TYPE["COMMUNITY_LOGO"] = "community-logo";
    SIGNED_URL_UPLOAD_TYPE["SPACE_COVERPHOTO"] = "space-coverphoto";
    SIGNED_URL_UPLOAD_TYPE["SGT_SPLASH_IMAGE"] = "sgt-splash-image";
    SIGNED_URL_UPLOAD_TYPE["CASA_CONTEXT"] = "casa-context";
})(SIGNED_URL_UPLOAD_TYPE || (SIGNED_URL_UPLOAD_TYPE = {}));
const useSignedURL = () => {
    const [signedURL, setSignedURL] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const api = (_a) => __awaiter(void 0, [_a], void 0, function* ({ uploadType, fileName }) {
        try {
            setLoading(true);
            setError(null);
            setSignedURL(null);
            const res = yield getSignedURL(uploadType, {
                params: {
                    path: fileName,
                },
            });
            setSignedURL(res);
            return res;
        }
        catch (error) {
            setError(error);
        }
        finally {
            setLoading(false);
        }
    });
    return [api, signedURL, loading, error];
};

export { SIGNED_URL_UPLOAD_TYPE, useSignedURL };
